// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineHeader_header__i\\+Rdm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.6rem;
  padding: 0.6rem 0.8rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.85rem;
  white-space: nowrap;
}

/* Левая часть */
.TimelineHeader_left__DTj11 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.TimelineHeader_left__DTj11 h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

.TimelineHeader_link__xxzq8 {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  font-size: 0.85rem;
  padding: 0;
}

.TimelineHeader_link__xxzq8:hover {
  text-decoration: underline;
}

/* Центральная часть */
.TimelineHeader_controls__kQ4pJ {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  justify-content: center;
}

.TimelineHeader_select__KHS8B {
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  background: #fff;
  color: #1e293b;
  cursor: pointer;
}

.TimelineHeader_dim__uECuf {
  color: #64748b;
  font-size: 0.8rem;
}

.TimelineHeader_smallBtn__4C1v- {
  background: #e2e8f0;
  border: none;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s;
}

.TimelineHeader_smallBtn__4C1v-:hover {
  background: #cbd5e1;
}

/* Правая часть */
.TimelineHeader_metrics__ry2FT {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.TimelineHeader_statGroup__FNX14 {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.TimelineHeader_stat__LUZnP {
  text-align: right;
}

.TimelineHeader_label__XuJOh {
  display: block;
  font-size: 0.7rem;
  color: #64748b;
  line-height: 1;
}

.TimelineHeader_stat__LUZnP b {
  font-size: 0.85rem;
  color: #1e293b;
}

/* статусы */
.TimelineHeader_statusGroup__2vDFT {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.TimelineHeader_progressBar__JVEhd {
  width: 90px;
  height: 6px;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  background: #e5e7eb;
}

.TimelineHeader_progressBar__JVEhd div {
  height: 100%;
  transition: width 0.3s;
}

.TimelineHeader_legend__ItKjB {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
  color: #475569;
}

@media (max-width: 850px) {
  .TimelineHeader_header__i\\+Rdm {
    flex-direction: column;
    align-items: stretch;
    gap: 0.4rem;
  }

  .TimelineHeader_controls__kQ4pJ {
    justify-content: flex-start;
  }

  .TimelineHeader_metrics__ry2FT {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/Logist/Routes/modal/timeline/TimelineHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.6rem;\r\n  padding: 0.6rem 0.8rem;\r\n  background: #f8fafc;\r\n  border-bottom: 1px solid #e2e8f0;\r\n  font-size: 0.85rem;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Левая часть */\r\n.left {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n}\r\n\r\n.left h3 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #1e293b;\r\n}\r\n\r\n.link {\r\n  background: none;\r\n  border: none;\r\n  color: #2563eb;\r\n  cursor: pointer;\r\n  font-size: 0.85rem;\r\n  padding: 0;\r\n}\r\n\r\n.link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Центральная часть */\r\n.controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.select {\r\n  border: 1px solid #cbd5e1;\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n  font-size: 0.8rem;\r\n  background: #fff;\r\n  color: #1e293b;\r\n  cursor: pointer;\r\n}\r\n\r\n.dim {\r\n  color: #64748b;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.smallBtn {\r\n  background: #e2e8f0;\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 2px 6px;\r\n  font-size: 0.8rem;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.smallBtn:hover {\r\n  background: #cbd5e1;\r\n}\r\n\r\n/* Правая часть */\r\n.metrics {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.statGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.7rem;\r\n}\r\n\r\n.stat {\r\n  text-align: right;\r\n}\r\n\r\n.label {\r\n  display: block;\r\n  font-size: 0.7rem;\r\n  color: #64748b;\r\n  line-height: 1;\r\n}\r\n\r\n.stat b {\r\n  font-size: 0.85rem;\r\n  color: #1e293b;\r\n}\r\n\r\n/* статусы */\r\n.statusGroup {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n}\r\n\r\n.progressBar {\r\n  width: 90px;\r\n  height: 6px;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  background: #e5e7eb;\r\n}\r\n\r\n.progressBar div {\r\n  height: 100%;\r\n  transition: width 0.3s;\r\n}\r\n\r\n.legend {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  font-size: 0.8rem;\r\n  color: #475569;\r\n}\r\n\r\n@media (max-width: 850px) {\r\n  .header {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n    gap: 0.4rem;\r\n  }\r\n\r\n  .controls {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .metrics {\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `TimelineHeader_header__i+Rdm`,
	"left": `TimelineHeader_left__DTj11`,
	"link": `TimelineHeader_link__xxzq8`,
	"controls": `TimelineHeader_controls__kQ4pJ`,
	"select": `TimelineHeader_select__KHS8B`,
	"dim": `TimelineHeader_dim__uECuf`,
	"smallBtn": `TimelineHeader_smallBtn__4C1v-`,
	"metrics": `TimelineHeader_metrics__ry2FT`,
	"statGroup": `TimelineHeader_statGroup__FNX14`,
	"stat": `TimelineHeader_stat__LUZnP`,
	"label": `TimelineHeader_label__XuJOh`,
	"statusGroup": `TimelineHeader_statusGroup__2vDFT`,
	"progressBar": `TimelineHeader_progressBar__JVEhd`,
	"legend": `TimelineHeader_legend__ItKjB`
};
export default ___CSS_LOADER_EXPORT___;
